module.exports = __webpack_public_path__ + "static/resolved-8a5c1747feafe66726b2bd9358204d5b.jpg";